import { render, staticRenderFns } from "./JobPrice.vue?vue&type=template&id=4a309734"
import script from "./JobPrice.vue?vue&type=script&lang=js"
export * from "./JobPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports